// extracted by mini-css-extract-plugin
export default {"notFound":"KhPRcIqwKOi2WXhO_QTo"};